module.exports = __webpack_public_path__ + "static/img/image_solutions_hpc_02.fb14fb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_hpc_02.png
// module id = qMdX
// module chunks = 10